const MIN_ID_LENGTH = 2;

export const KOREAN_PATTERN = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
export const NUMBER_ONLY_PATTERN = /^[0-9*$]/;
export const ID_PATTERN = /^[a-zA-Z0-9.]*$/;
export const NICKNAME_PATTERN = /^[a-zA-Z0-9ㄱ-ㅎㅏ-ㅣ가-힣]*$/;

export const isValidId = (id: string): boolean => {
  if (id.length < MIN_ID_LENGTH) return false;

  const pattern = /[A-Za-z0-9.]/;
  const isValidInput = pattern.test(id);
  const firstIsNotNumber = Number.isNaN(parseInt(id[0], 10));
  return isValidInput && firstIsNotNumber;
};

export const testPassword = (pwd: string): boolean => {
  // const notAllowCharPattern = /[\<\>\(\)\#\*\'\/\|]/;
  const spacePattern = /\s/;
  const koreanPattern = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;

  // if (pwd.search(notAllowCharPattern) >= 0) return false;
  if (pwd.search(spacePattern) >= 0) return false;
  if (pwd.search(koreanPattern) >= 0) return false;

  return true;
};

export const isValidNickname = (nickname: string): boolean => {
  return NICKNAME_PATTERN.test(nickname);
};


